import axiosApi from '../../axiosApi'

// initial state
const state = {
  userData: {},
  showModalButtons: false,
  openAfterResponse: false
}

// getters
const getters = {
  getUserData: (state) => {
    return state.userData
  }
}

// actions
const actions = {
  sendVerification ({commit, state}, payload) {
    return axiosApi.post('/sendVerification', payload)
      .then(res => {
        return res.data
      }).catch(e => {
        console.log(e)
      })
  },
  getUserIps ({commit, state}, payload) {
    return axiosApi.post('/getUserIps', payload)
      .then(res => {
        return res.data
      }).catch(e => {
        console.log(e)
      })
  },
  toggleBlockUserIp ({commit, state}, payload) {
    return axiosApi.post('/toggleBlockUserIp', payload)
      .then(res => {
        return res.data
      }).catch(e => {
        console.log(e)
      })
  },
  getBlockUsers ({commit, state}, payload) {
    return axiosApi.get(`/getBlockUsers`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  getEmailCount ({commit, state}, payload) {
    return axiosApi.get(`/getEmailCount`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  getCompanies ({commit, state}, payload) {
    return axiosApi.get(`/getCompanies`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  getUsers ({commit, state}, payload) {
    return axiosApi.get(`/getUsers`)
      .then(response => {
        return response.data
      })
      .catch(e => {
        console.log(e)
      })
  },
  updateCompanyStatus ({commit, state}, payload) {
    return axiosApi.post(`/updateCompanyStatus`, payload)
      .then(response => {
        return response.data
      }).catch(e => {
        console.log(e)
      })
  },
  confirmationResend ({commit, state}, payload) {
    return axiosApi.post(`/resend`, payload)
      .then(response => {
        return response.data
      }).catch(e => {
        console.log(e)
      })
  },
  signIn ({commit, state}, payload) {
    return axiosApi.post(`/auth/signIn`, {
      data: JSON.stringify(payload)
    })
      .then(response => {
        if (response.data.token) {
          commit('setUserData', response.data.user)
        }
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  signUp ({commit, state}, payload) {
    return axiosApi.post(`/auth/signUp`, {
      data: JSON.stringify(payload)
    })
      .then(response => {
        if (response.data.token) {
          commit('setUserData', response.data.user)
        }
        return response.data
      })
      .catch(e => {
        return e.response
      })
  },
  userInfo ({commit, state}) {
    const token = localStorage.getItem('token')
    if (!token) {
      setTimeout(() => {
        commit('openAfterResponse', true)
      }, 1500)
      return
    }
    if (!state.userData.id) {
      return axiosApi.get(`/profile/userInfo`)
        .then(response => {
          if (response.data.user) {
            commit('setUserData', response.data.user)
            commit('openAfterResponse', true)
            return {user: response.data.user}
          }
        })
        .catch(e => {
          return e.response
        })
    }
  },
  signOut ({commit, state}, payload) {
    localStorage.removeItem('token')
    localStorage.removeItem('expTime')
    commit('setUserData', {})
  },
  updateUserData ({commit, state}, payload) {
    commit('setUserData', payload.userData)
  },
  resendConfirmationCode ({commit, state}, payload) {
    return axiosApi.post(`/auth/resendConfirmationCode`, {email: payload.email})
      .then(response => {
        return response
      })
      .catch(e => {
        return e.response
      })
  },
  refreshToken ({commit, state}, payload) {
    return axiosApi.post(`/auth/refreshToken`, {token: payload.token})
      .then(response => {
        if (response.data && response.data.token) {
          localStorage.setItem('token', response.data.token)
        }
        return response
      })
      .catch(e => {
        return e.response
      })
  }
}

// mutations
const mutations = {
  setUserData (state, user) {
    state.userData = user
  },
  openAfterResponse (state, show) {
    state.showModalButtons = show
    state.openAfterResponse = show
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js